export enum CopyStatus {
  DONE,
  ERROR,
}

export type ChatShareDialog = {
  chatSessionID: string;
  isShowCopyDialog: boolean;
  snapshotID: string;
};
